import React from 'react';
import { JobFull } from '../comonents/JobFull';

const JobPage = () => {
    return (
        <div className='h-window'>
            <JobFull/>
        </div>
    );
};

export default JobPage;